var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('p',[_vm._v("您还未绑定店铺")]),_c('ManualHelp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }